import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ShieldAlert } from "lucide-react";

interface PermissionAlertProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: string;
}

export function PermissionAlert({ open, onOpenChange, action }: PermissionAlertProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10">
              <ShieldAlert className="h-5 w-5 text-destructive" />
            </div>
            <AlertDialogTitle>Permissão Necessária</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-2">
            <p>Você não tem permissão para <strong>{action}</strong> neste módulo.</p>
            <p className="text-muted-foreground">
              Para realizar esta ação, solicite ao proprietário da organização que altere suas permissões 
              em <strong>Equipe → Membros → Permissões</strong>.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            Entendi
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
